"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCompanyBuildingFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13 3 13 7 24 7 24 21 0 21 0 3 13 3ZM5.5 15 3.5 15 3.5 17 5.5 17 5.5 15ZM9.5 15 7.5 15 7.5 17 9.5 17 9.5 15ZM16.5 15 14.5 15 14.5 17 16.5 17 16.5 15ZM20.5 15 18.5 15 18.5 17 20.5 17 20.5 15ZM16.5 11 14.5 11 14.5 13 16.5 13 16.5 11ZM5.5 11 3.5 11 3.5 13 5.5 13 5.5 11ZM9.5 11 7.5 11 7.5 13 9.5 13 9.5 11ZM20.5 11 18.5 11 18.5 13 20.5 13 20.5 11ZM5.5 7 3.5 7 3.5 9 5.5 9 5.5 7ZM9.5 7 7.5 7 7.5 9 9.5 9 9.5 7Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCompanyBuildingFilled')(IconCompanyBuildingFilled);